import { Link } from 'react-router-dom';
import { useScrollReveal } from '../../hooks/useScrollReveal';

export default function ServicesSection() {
  const { ref, isVisible } = useScrollReveal({ threshold: 0.08, distance: 48, duration: 1000 });
  const { ref: ref2, style: style2 } = useScrollReveal({ threshold: 0.08, direction: 'left', distance: 30, duration: 1000, delay: 200 });

  return (
    <section
      ref={ref}
      className="w-full bg-white"
    >
      <div
        className="grid grid-cols-1 lg:grid-cols-2 min-h-[600px]"
        style={isVisible ? { opacity: 1, transform: 'translateY(0px)', transition: 'opacity 1000ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0ms, transform 1000ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0ms' } : { opacity: 0, transform: 'translateY(48px)', transition: 'opacity 1000ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0ms, transform 1000ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 0ms', willChange: 'opacity, transform' }}
      >
        {/* Alta Costura Column */}
        <div className="relative flex flex-col justify-center px-8 md:px-16 lg:px-20 py-20 lg:py-28 bg-brand-cream/40">
          <div className="absolute right-0 top-0 bottom-0 w-px bg-brand-gray-200 hidden lg:block" />

          <span className="font-sans text-[11px] tracking-[0.2em] uppercase text-brand-gray-400 font-medium">
            Haute Couture
          </span>

          <h2 className="font-serif text-brand-black text-[clamp(2rem,4vw,3.5rem)] font-medium leading-[1.15] mt-6">
            Diseño Exclusivo
            <br />
            <span className="italic">Hecho a Medida</span>
          </h2>

          <p className="font-sans text-brand-gray-500 text-[15px] leading-[1.8] mt-8 max-w-md">
            En nuestro atelier de Rambla de Catalunya, 85, Principal - 2, Barcelona, cada prenda es única.
            Desde vestidos de gala hasta piezas bordadas en oro, trabajamos desde
            la emoción y la energía para crear prendas que son verdaderos templos de arte.
          </p>

          <div ref={ref2} className="mt-10 w-full max-w-sm aspect-square overflow-hidden rounded-3xl" style={style2}>
            <img
              src="/assets/anthony/service-embroidery-bw.jpg"
              alt="Detalle artesanal de confección en el atelier"
              className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
            />
          </div>

          <Link
            to="/alta-costura"
            className="inline-block mt-10 font-sans text-sm tracking-widest uppercase text-brand-black border-b border-brand-black pb-1 w-fit hover:text-brand-gray-600 hover:border-brand-gray-600 transition-colors"
          >
            Descubrir Colecciones
          </Link>
        </div>

        {/* Prêt-à-porter Column */}
        <div className="flex flex-col justify-center px-8 md:px-16 lg:px-20 py-20 lg:py-28 bg-white">
          <span className="font-sans text-[11px] tracking-[0.2em] uppercase text-brand-gray-400 font-medium">
            Prêt-à-porter & Arreglos
          </span>

          <h2 className="font-serif text-brand-black text-[clamp(2rem,4vw,3.5rem)] font-medium leading-[1.15] mt-6">
            Arreglos
            <br />
            <span className="italic">Profesionales</span>
          </h2>

          <div className="mt-8 space-y-5">
            {[
              { icon: 'ri-scissors-cut-line', text: 'Ajustes y entallados perfectos' },
              { icon: 'ri-tools-line', text: 'Reparaciones de calidad' },
              { icon: 'ri-brush-line', text: 'Personalización básica' },
              { icon: 'ri-time-line', text: 'Servicio rápido y eficiente' },
            ].map((item, i) => (
              <div
                key={item.text}
                className="flex items-center gap-4"
                style={isVisible ? {
                  opacity: 1,
                  transform: 'translateX(0px)',
                  transition: `opacity 700ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${400 + i * 120}ms, transform 700ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${400 + i * 120}ms`,
                } : {
                  opacity: 0,
                  transform: 'translateX(24px)',
                  transition: `opacity 700ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${400 + i * 120}ms, transform 700ms cubic-bezier(0.25, 0.46, 0.45, 0.94) ${400 + i * 120}ms`,
                  willChange: 'opacity, transform',
                }}
              >
                <div className="w-10 h-10 flex items-center justify-center rounded-full bg-brand-gray-50">
                  <i className={`${item.icon} text-brand-gray-600 text-lg`} />
                </div>
                <span className="font-sans text-brand-gray-600 text-[15px]">{item.text}</span>
              </div>
            ))}
          </div>

          <div className="mt-10 w-full max-w-lg aspect-video overflow-hidden rounded-3xl" style={isVisible ? {
            opacity: 1,
            transform: 'translateY(0px)',
            transition: 'opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 600ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 600ms',
          } : {
            opacity: 0,
            transform: 'translateY(32px)',
            transition: 'opacity 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 600ms, transform 900ms cubic-bezier(0.25, 0.46, 0.45, 0.94) 600ms',
            willChange: 'opacity, transform',
          }}>
            <img
              src="/assets/anthony/service-arreglos.jpg"
              alt="Anthony Sánchez preparando una prenda para un arreglo"
              className="w-full h-full object-cover object-top transition-transform duration-700 hover:scale-105"
            />
          </div>

          <Link
            to="/pret-a-porter"
            className="inline-flex items-center justify-center mt-10 bg-brand-gray-50 text-brand-black font-sans text-sm tracking-widest uppercase px-8 py-4 rounded-full w-fit hover:bg-brand-black hover:text-white transition-all duration-300 whitespace-nowrap"
          >
            Solicitar Cita
          </Link>
        </div>
      </div>
    </section>
  );
}